import { Button } from "@chakra-ui/react";

const CustomButton = ({
  label,
  onClick,
  mr,
  mt,
  colorScheme = "red",
  variant = "outline",
}) => {
  return (
    <Button
      mt={mt}
      mr={mr}
      onClick={onClick}
      colorScheme={colorScheme}
      variant={variant}
    >
      {label}
    </Button>
  );
};

export default CustomButton;
